module.exports = __webpack_public_path__ + "static/media/militaer-krigshistorisk.78518d7b.jpg";